import type { API } from 'chessboard/api/config/types';

/**
 * Create the isGameOver method.
 */
export function createIsGameOver(context: API.Context) {
  /**
   * Determine whether or not the game has finished. This can be determined either by
   * checkmate/stalemate/insufficient material, or by a result on the PGN headers,
   * e.g. resigned, fifty move rule, draw agreed, etc.
   */
  return function isGameOver(): boolean {
    const { api } = context;

    return api.getResult() !== '*';
  };
}
